<template>
    <v-form name="create-quotation-form">
        <div class="grid">
            <FormInputText fieldName="quotation_name"
                           label="Quotation name"
                           validation="required"
                           v-model:field="quotation_name" />
        </div>

        <div class="grid"
             style="margin-top:20px">
            <Button @click.stop="createQuotation"
                    :class="buttonClass('green')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-floppy-disk"></i><span>{{ __('Save') }}</span></template>
            </Button>

            <Button @click="cancel"
                    :class="buttonClass('gray')">
                <template class="flex items-center gap-1"><i class="fa-regular fa-trash-can"></i><span>{{ __('Cancel') }}</span></template>
            </Button>
        </div>
    </v-form>
</template>

<script setup>
import { ref } from 'vue'
import { useForm, usePage } from '@inertiajs/vue3'
import Button from 'primevue/button';
import FormInputText from '@crud/FormInputText.vue'
import { __, buttonClass } from '@pages/Helper/utils.js'
import { validation } from '@pages/Helper/crud_utils.js'

// -----------------------------------------------------
const props = defineProps({
    selectedRows: Array,
    formProps: Object
})

const isLoading = ref(false)
const page = usePage()
const quotation_name = ref('')
const isCreateQuotationModalOpen = defineModel('isCreateQuotationModalOpen')

// -----------------------------------------------------

const cancel = () => {
    isCreateQuotationModalOpen.value = false
}
// -----------------------------------------------------

const createQuotation = async () => {
    const offerIds = props.selectedRows.map(row => row.id)
    const formData = {
        'offerIds': offerIds,
        'quotation_name': quotation_name.value,
    }

    if (validation(formData, 'create-quotation-form')) {
        isLoading.value = true


        useForm(formData).post(route('quotation-create-from-offers'), {
            preserveState: true,
            preserveScroll: true,
            forceFormData: true,
            onSuccess: () => {
            },
            onError: (errors) => {
                console.err(errors)
            },
            onFinish: () => {
                isLoading.value = false
                isCreateQuotationModalOpen.value = false
                props.formProps.getLazyData()
                props.formProps.clearSelection()
            }
        })
    }
}
// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
